import {
    differenceInCalendarDays,
    eachDayOfInterval, endOfDay,
    isWithinInterval,
    startOfDay,
    startOfToday
} from "date-fns";

import {isoFmt} from "../../shared/utils";
import {ABSENCE_REQUEST_KIND, DAY_STATUS} from "../../shared/constants";


export const TIME_RANGE = {
    PAST: 'PAST',
    TODAY: 'TODAY',
    TODAY_PAST: 'TODAY_PAST',
    FUTURE: 'FUTURE',
}

export const SELECTION_MODE = {
    SINGLE: 'SINGLE',
    RANGE: 'RANGE',
}

export const VISIBILITY_LEVEL = {
    HIDDEN: 'HIDDEN',
    DISABLED: 'DISABLED',
    VISIBLE: 'VISIBLE'
}


export const addKeysToStatusChangesMapping = (mapping) => {
    mapping = {...mapping};

    for (const dayStatus in mapping) {
        mapping[dayStatus] = mapping[dayStatus].map(button => {
            const {status, timeRange, selectionMode} = button;
            const key = [status, timeRange, selectionMode].filter(Boolean).join('-');
            return {...button, key};
        })
    }

    return mapping;
}


export const getButtonVisibilityLevel = ({status, timeRange, selectionMode}, selectRange, selectedRange, selectedDay) => {
    if (selectionMode) {
        if ((selectionMode === SELECTION_MODE.RANGE && !selectRange) || (selectionMode === SELECTION_MODE.SINGLE && selectRange)) {
            return VISIBILITY_LEVEL.HIDDEN;
        }
    }

    if (!selectRange) {
        selectedRange = [startOfDay(selectedDay), endOfDay(selectedDay)];
    }

    const today = startOfToday();
    const isSelectedToday = isWithinInterval(today, {start: selectedRange[0], end: selectedRange[1]});
    const isSelectedInPast = differenceInCalendarDays(today, selectedRange[0]) > 0;
    const isSelectedInFuture = differenceInCalendarDays(selectedRange[1], today) > 0;

    if (timeRange) {
        if ((timeRange === TIME_RANGE.TODAY && (isSelectedInPast || isSelectedInFuture)) ||
            (timeRange === TIME_RANGE.FUTURE && (isSelectedToday || isSelectedInPast)) ||
            (timeRange === TIME_RANGE.PAST && (isSelectedToday || isSelectedInFuture)) ||
            (timeRange === TIME_RANGE.TODAY_PAST && isSelectedInFuture))
            return VISIBILITY_LEVEL.DISABLED;
    }

    return VISIBILITY_LEVEL.VISIBLE;
}


export const getAvailableButtons = (timeline, selectRange, selectedDay, selectedRange, statusChangesMapping, isSelfSelected) => {
    let buttons = undefined;

    if (selectRange) {
        const [startDate, endDate] = selectedRange;
        const interval = {start: startDate, end: endDate};

        const buttonsForEachDay = eachDayOfInterval(interval).map(date => {
            const dateISO = isoFmt(date);
            const dayStatus = timeline[dateISO]?.status;
            const buttons = statusChangesMapping[dayStatus] ?? [];
            return buttons;
        });

        buttons = [...buttonsForEachDay.slice(1).reduce((acc, val) => {
            const result = [];
            for (const button1 of acc) {
                if (val.findIndex(button2 => button2.key === button1.key) !== -1)
                    result.push(button1);
            }
            return result;
        }, buttonsForEachDay[0])];
    } else {
        if (!selectedDay) {
            return [];
        }

        const selectedDayISO =  isoFmt(selectedDay);
        const dayStatus = timeline[selectedDayISO]?.status;
        buttons = statusChangesMapping[dayStatus] ?? [];
    }

    if (!isSelfSelected) {
        buttons = buttons.filter(({status}) => status !== DAY_STATUS.VACATION_PAID && status !== DAY_STATUS.VACATION_UNPAID)
    }

    return buttons;
}


export const transformDayStatusToVacationKind = (dayStatus) => {
    switch (dayStatus) {
        case DAY_STATUS.TIME_OFF_PAID: return ABSENCE_REQUEST_KIND.TIME_OFF_PAID;
        case DAY_STATUS.TIME_OFF_UNPAID: return ABSENCE_REQUEST_KIND.TIME_OFF_UNPAID;
        case DAY_STATUS.VACATION_PAID: return ABSENCE_REQUEST_KIND.VACATION_PAID;
        case DAY_STATUS.VACATION_UNPAID: return ABSENCE_REQUEST_KIND.VACATION_UNPAID;
        case DAY_STATUS.ILLNESS: return ABSENCE_REQUEST_KIND.ILLNESS;
        default: throw new Error("Недопустимое значение dayStatus");
    }
}